export const agentApiVersionDefault = "v1"
export const AIAssistAgentIdDefault = "aiassist2"

export const mergeUsersDefault = true
export const requireAuthMessageDefaultKey = "agent:default-value.authorization-required"
